// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3489":"b9aa07cce5063c7f","5644":"95077a71aa6bd32a"}[chunkId] + ".css";
};